import React from 'react';
import E025Table from './Components/E025Table';

const E025Page = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <E025Table />
      </div>
    </div>
  );
};

export default E025Page;
